
import Symbol from "slotworks/components/matrix/symbol/symbol-component";
import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contract";

export default class AbstractSymbolBehaviour {

    public validSymbols: string[];

    protected symbol: Symbol;

    protected behaviourSprite: PIXI.Sprite;

    constructor(symbol: Symbol) {
        this.symbol = symbol;
    }

    public static(...args: any[]): void {
        if (this.behaviourSprite) {
            this.behaviourSprite.visible = false;
        }
    }

    public land(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public win(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public cycle(...args: any[]): Contract<void> {
        return this.win();
    }

    public highlight(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public dim(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public expand(x: number = 0, y: number = 0): Contract<void> {
        return Contract.empty();
    }

    public anticipate(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public stop(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public display(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public stick(...args: any[]) {
        // Stick
    }

    public changeSymbol(...args: any[]): void {
        // Symbol changed into new symbol
    }

    public updateTransform(...args: any[]): void {
        // Reposition "behaviourSprite" (sprite which should match the static sprite's position and size)
        // TODO: Could remove width and height from this?
        if (this.behaviourSprite) {
            const symbolTransform = this.symbol.getTransform();

            const globalPosition = Layers.MatrixContent.localToGlobal(symbolTransform);
            const localPosition = Layers.SymbolAnimations.globalToLocal(globalPosition);

            this.behaviourSprite.x = localPosition.x;
            this.behaviourSprite.y = localPosition.y;
            this.behaviourSprite.width = symbolTransform.width;
            this.behaviourSprite.height = symbolTransform.height;
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour.ts